var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 112,
    viewBox: "0 0 149 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.1048 41.3601L70.6055 42.8608L72.1062 41.3601L70.6055 39.8594L69.1048 41.3601Z",
    fill: "#FF5D0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5742 20.6372L77.7246 23.7876L80.875 20.6372L77.7246 17.4867L74.5742 20.6372Z",
    fill: "#FF5D0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2872 36.9893L89.3945 39.0967L91.5019 36.9893L89.3945 34.8819L87.2872 36.9893Z",
    fill: "#FF5D0E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.09 24.6798L27.9893 22.2715C27.3722 21.7898 26.6196 21.534 25.8368 21.534H6.22398C3.37914 21.534 1.07617 19.231 1.07617 16.3861V5.71422C1.07617 2.86937 3.37914 0.566406 6.22398 0.566406H26.3336C29.1784 0.566406 31.4814 2.86937 31.4814 5.71422V24.4842C31.4814 24.6798 31.2556 24.8003 31.09 24.6798Z",
    fill: "#0A0A0A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4687 13.4812H14.8346V12.1868C14.8346 11.7202 14.8948 11.3589 15.0152 11.1181C15.1356 10.8772 15.3915 10.5611 15.7829 10.1547L16.9569 8.93552C17.1376 8.72479 17.2128 8.45385 17.2128 8.12271C17.2128 7.79156 17.1225 7.52062 16.9419 7.29484C16.7613 7.06906 16.5204 6.9637 16.2194 6.9637C15.9183 6.9637 15.6624 7.09917 15.4668 7.35505C15.2711 7.61094 15.1356 7.95713 15.0905 8.39365H12.3359C12.4564 7.23463 12.8778 6.33151 13.6003 5.66922C14.3228 5.00693 15.2109 4.67578 16.2946 4.67578C17.3784 4.67578 18.2514 4.97682 18.9288 5.56385C19.6061 6.15088 19.9372 6.9637 19.9372 8.00229C19.9372 8.4689 19.877 8.8151 19.7566 9.04089C19.6362 9.26667 19.5609 9.43224 19.5158 9.52255C19.4706 9.62792 19.3653 9.76338 19.1997 9.95906C19.0341 10.1547 18.9137 10.2902 18.8685 10.3354C18.5976 10.6063 18.3267 10.8772 18.0858 11.1181C17.8299 11.3589 17.6794 11.5546 17.5891 11.7202C17.5139 11.8707 17.4687 12.1115 17.4687 12.4276V13.4812ZM15.1055 16.7777C14.8045 16.4766 14.669 16.1154 14.669 15.6939C14.669 15.2724 14.8195 14.9112 15.1055 14.6102C15.4066 14.3091 15.7678 14.1736 16.1893 14.1736C16.6107 14.1736 16.972 14.3242 17.273 14.6102C17.5741 14.9112 17.7095 15.2724 17.7095 15.6939C17.7095 16.1154 17.559 16.4766 17.273 16.7777C16.972 17.0787 16.6107 17.2142 16.1893 17.2142C15.7678 17.2292 15.4066 17.0787 15.1055 16.7777Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0282 50.7062L41.6561 46.5669H63.9784L72.9043 60.4299L71.8807 110.899H26.3482L18.9727 69.2353L22.0282 50.7062Z",
    fill: "#FF5D0E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.911 28.1426C66.5385 26.6374 67.6223 19.7134 67.1858 16.4471C66.4482 10.9832 62.3842 6.69338 56.7396 6.99442C53.9249 7.14494 51.08 7.41588 48.4309 8.37921C45.7817 9.34254 43.3282 11.0735 41.9735 13.5421C40.9199 12.4433 39.0233 12.4884 37.8041 13.4066C33.6046 16.5977 37.4579 23.8528 39.1437 27.3298C40.6189 30.3703 42.5907 33.2001 44.999 35.5783C44.999 35.5783 62.8959 28.1426 62.911 28.1426Z",
    fill: "#0A0A0A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.911 28.1426C66.5385 26.6374 67.6223 19.7134 67.1858 16.4471C66.4482 10.9832 62.3842 6.69338 56.7396 6.99442C53.9249 7.14494 51.08 7.41588 48.4309 8.37921C45.7817 9.34254 43.3282 11.0735 41.9735 13.5421C40.9199 12.4433 39.0233 12.4884 37.8041 13.4066C33.6046 16.5977 37.4579 23.8528 39.1437 27.3298C40.6189 30.3703 42.5907 33.2001 44.999 35.5783C44.999 35.5783 62.8959 28.1426 62.911 28.1426Z",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.685 37.942L54.1647 49.2913C53.7282 52.5275 50.9737 54.9358 47.7074 54.9358C43.6885 54.9358 40.6329 51.3384 41.2801 47.3797L43.6885 32.5835L55.685 37.942Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.685 37.942L54.1647 49.2913C53.7282 52.5275 50.9737 54.9358 47.7074 54.9358C43.6885 54.9358 40.6329 51.3384 41.2801 47.3797L43.6885 32.5835L55.685 37.942Z",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9066 16.0105C58.9066 16.0105 69.7892 26.7877 64.4909 39.296C59.1926 51.8043 44.9985 35.5782 44.9985 35.5782L43.5535 34.4041C43.5535 34.4041 42.1085 19.5326 46.4435 14.9267C50.7785 10.3057 58.9066 16.0105 58.9066 16.0105Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5989 34.0883C43.5989 34.0883 42.1087 19.5329 46.4437 14.912C50.7787 10.291 58.9069 16.0108 58.9069 16.0108C58.9069 16.0108 69.7895 26.7881 64.4912 39.2963C60.969 47.6352 53.5032 43.2099 48.8972 39.3264",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6155 19.3975C61.6155 19.3975 55.1581 19.3975 51.3951 16.5678C51.2597 16.4624 51.079 16.5226 51.0188 16.6882C50.5522 18.088 48.5804 23.4917 45.8861 23.5971V29.5125H43.3724C43.3724 29.5125 40.1211 26.6526 41.1145 21.851C42.108 17.0494 44.8324 12.0973 48.3546 11.4049C51.8768 10.7125 59.3125 12.5789 60.893 14.7766C62.4885 16.9742 61.6155 19.3975 61.6155 19.3975Z",
    fill: "#0A0A0A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6162 19.3978C61.6162 19.3978 55.1588 19.3978 51.3958 16.568C51.2603 16.4627 51.0797 16.5229 51.0195 16.6885C50.5529 18.0883 48.5811 23.492 45.8867 23.5974V29.5128H43.373",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5412 27.7967C47.5412 27.7967 43.5675 23.6122 42.0322 25.7496C40.2259 28.2633 40.7828 31.8457 42.0322 32.809C43.0858 33.6219 47.5412 33.095 47.5412 33.095V27.7967Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5412 27.7967C47.5412 27.7967 43.5675 23.6122 42.0322 25.7496C40.2259 28.2633 40.7828 31.8457 42.0322 32.809C43.0858 33.6219 47.5412 33.095 47.5412 33.095",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9921 30.2799C45.9921 30.2799 44.3815 30.4003 43.373 28.7295",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.932 36.7983C61.932 36.7983 58.7259 36.723 57.7324 34.8716C57.7324 34.8716 56.2724 38.2884 58.5603 39.0109C60.2913 39.5678 61.932 36.7983 61.932 36.7983Z",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6946 27.3449C56.7999 28.0975 57.2665 28.6394 57.7332 28.5641C58.1998 28.4888 58.4858 27.8416 58.3804 27.089C58.275 26.3364 57.8084 25.7945 57.3418 25.8698C56.8752 25.945 56.5742 26.6073 56.6946 27.3449Z",
    fill: "#0A0A0A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6692 27.3449C62.7745 28.0975 63.2412 28.6394 63.7078 28.5641C64.1744 28.4888 64.4604 27.8416 64.355 27.089C64.2497 26.3364 63.783 25.7945 63.3164 25.8698C62.8498 25.945 62.5488 26.6073 62.6692 27.3449Z",
    fill: "#0A0A0A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5168 27.33C60.8781 28.5944 61.2393 29.8588 61.6006 31.1382C61.6909 31.4392 61.7812 31.7553 61.8565 32.0564C61.9317 32.3273 61.9919 32.6133 61.9769 32.8993C61.9618 33.11 61.8866 33.2907 61.736 33.4261C61.6307 33.5164 61.4501 33.6067 61.3447 33.5616C61.1641 33.4863 60.9383 33.5014 60.8329 33.6971C60.7426 33.8626 60.7727 34.1336 60.9684 34.2088C61.5705 34.4647 62.2027 34.1938 62.5338 33.6519C62.9252 33.0197 62.7144 32.237 62.5188 31.5747C62.0973 30.0846 61.6758 28.6095 61.2544 27.1193C61.1039 26.6527 60.3814 26.8634 60.5168 27.33Z",
    fill: "#0A0A0A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2886 23.6576C58.2886 23.6576 55.3986 23.2512 54.1191 26.0659",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4003 24.8611C64.4003 24.8611 63.3767 23.8677 62.0371 24.0483",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2344 67.3677C34.0669 63.5351 34.0669 57.3213 30.2344 53.4888C26.4018 49.6562 20.188 49.6562 16.3555 53.4888C12.5229 57.3213 12.5229 63.5351 16.3555 67.3677C20.188 71.2002 26.4018 71.2002 30.2344 67.3677Z",
    fill: "#FF5D0E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M70.916 63.3144C74.7486 59.4819 74.7486 53.2681 70.916 49.4355C67.0835 45.603 60.8697 45.603 57.0371 49.4355C53.2046 53.2681 53.2046 59.4819 57.0371 63.3144C60.8697 67.147 67.0835 67.147 70.916 63.3144Z",
    fill: "#FF5D0E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8563 58.0215L5.41211 85.5367H23.294L32.551 63.6811L13.8563 58.0215Z",
    fill: "#FF5D0E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2513 85.5369L37.186 56.5165C39.0976 54.3791 41.235 52.4524 43.5681 50.7666L55.4141 42.1869C55.8807 41.8557 56.4226 41.645 56.9946 41.645C57.7472 41.645 58.5299 41.9762 57.988 43.5265C57.8525 43.9028 57.6418 44.249 57.3558 44.535L52.0725 50.014C52.0725 50.014 54.6314 50.3752 54.9475 52.5427C54.9475 52.5427 56.8591 53.2652 56.7086 55.0715C56.7086 55.0715 58.56 56.9379 57.9579 58.684C57.4612 60.129 54.1046 63.2147 52.9455 64.2382C52.5843 64.5543 52.0725 64.6747 51.621 64.4941C51.1845 64.3135 50.7931 63.8468 51.0038 62.733L49.9953 61.9954L48.2342 63.3351C47.1505 64.1629 46.2925 65.2316 45.7055 66.4659L38.5407 81.6986C34.6422 89.3451 29.4794 96.2841 23.2779 102.215C14.6681 110.463 -0.429137 102.591 3.4242 91.3018L5.41107 85.5369H11.2513Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2513 85.5369L37.186 56.5165C39.0976 54.3791 41.235 52.4524 43.5681 50.7666L55.4141 42.1869C55.8807 41.8557 56.4226 41.645 56.9946 41.645C57.7472 41.645 58.5299 41.9762 57.988 43.5265C57.8525 43.9028 57.6418 44.249 57.3558 44.535L52.0725 50.014C52.0725 50.014 54.6314 50.3752 54.9475 52.5427C54.9475 52.5427 56.8591 53.2652 56.7086 55.0715C56.7086 55.0715 58.56 56.9379 57.9579 58.684C57.4612 60.129 54.1046 63.2147 52.9455 64.2382C52.5843 64.5543 52.0725 64.6747 51.621 64.4941C51.1845 64.3135 50.7931 63.8468 51.0038 62.733L49.9953 61.9954L48.2342 63.3351C47.1505 64.1629 46.2925 65.2316 45.7055 66.4659L38.5407 81.6986C34.6422 89.3451 29.4794 96.2841 23.2779 102.215C14.6681 110.463 -0.429138 102.591 3.4242 91.3018L5.41107 85.5369H11.2513Z",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9478 52.5269L53.834 53.6708",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M56.709 55.0562L55.5801 55.9593",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0195 62.7174L54.617 59.3457",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M68.706 47.7861L83.758 57.4195L75.2536 74.037L60.0059 65.3519L68.706 47.7861Z",
    fill: "#FF5D0E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7564 57.4192L87.4291 59.3459L95.0906 38.1826L100.359 25.5088H113.123V34.6002C113.123 35.7743 112.16 36.7226 110.986 36.7075L109.134 36.6774L106.696 64.2227C105.642 76.0687 92.9532 83.083 82.3716 77.6793L75.252 74.0367L83.7564 57.4192Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7564 57.4192L87.4291 59.3459L95.0906 38.1826L100.359 25.5088H113.123V34.6002C113.123 35.7743 112.16 36.7226 110.986 36.7075L109.134 36.6774L106.696 64.2227C105.642 76.0687 92.9532 83.083 82.3716 77.6793L75.252 74.0367L83.7564 57.4192Z",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3954 84.272L9.5957 87.5684",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41211 85.5367L8.07633 76.8667",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7388 68.3022L71.8809 110.9",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M75.253 74.0366L72.6641 72.5615",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7579 57.4191L79.8594 54.9355",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M109.507 34.5471C117.795 34.5471 124.514 27.8282 124.514 19.5401C124.514 11.252 117.795 4.5332 109.507 4.5332C101.219 4.5332 94.5 11.252 94.5 19.5401C94.5 27.8282 101.219 34.5471 109.507 34.5471Z",
    fill: "#0A0A0A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M111.467 16.614C111.183 15.7921 110.402 15.2017 109.483 15.2017C108.324 15.1971 107.38 16.1325 107.375 17.2916V17.3008V18.2911",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.24 23.7347H107.716C106.75 23.7347 105.967 22.9515 105.967 21.9852V20.0073C105.967 19.041 106.75 18.2578 107.716 18.2578H111.24C112.206 18.2578 112.989 19.041 112.989 20.0073V21.9852C112.989 22.9515 112.206 23.7347 111.24 23.7347Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M109.479 20.4839V21.5088",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M100.556 39.7027C105.131 35.6688 101.519 31.7251 101.519 31.7251L99.4567 27.646L103.114 23.0702C103.34 22.7992 103.491 22.4681 103.536 22.1219C103.792 20.5414 103.099 20.1952 102.467 20.1802C102.046 20.1802 101.624 20.3307 101.278 20.5866L96.1754 24.3496C94.5798 25.5237 93.8573 27.5557 94.3541 29.4824L96.0248 35.8946L100.556 39.7027Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M100.556 39.7027C105.131 35.6688 101.519 31.7251 101.519 31.7251L99.4567 27.646L103.114 23.0702C103.34 22.7992 103.491 22.4681 103.536 22.1219C103.792 20.5414 103.099 20.1952 102.467 20.1802C102.046 20.1802 101.624 20.3307 101.278 20.5866L96.1754 24.3496C94.5798 25.5237 93.8573 27.5557 94.3541 29.4824L96.0248 35.8946",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M121.25 107.182L132.088 75.8138C132.705 74.0076 131.38 72.1411 129.469 72.1411H85.6822C85.1554 72.1411 84.6888 72.4873 84.5383 72.984L73.1137 108.853H43.7923C43.2353 108.853 42.7988 109.305 42.7988 109.847C42.7988 110.404 43.2504 110.84 43.7923 110.84H116.118C118.436 110.84 120.498 109.365 121.25 107.182Z",
    fill: "#0A0A0A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2642 108.371L84.5082 72.9388C84.6587 72.4571 85.1102 72.126 85.622 72.126C86.4198 72.126 86.9767 72.8936 86.7359 73.6613L75.0554 109.636C74.8297 110.358 74.1523 110.84 73.3997 110.84H43.7923C43.2353 110.84 42.7988 110.388 42.7988 109.846C42.7988 109.29 43.2504 108.853 43.7923 108.853H72.6321C72.918 108.838 73.1739 108.657 73.2642 108.371Z",
    fill: "#9F99AA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7923 110.84C43.2353 110.84 42.7988 110.388 42.7988 109.847C42.7988 109.29 43.2504 108.853 43.7923 108.853H72.6321C72.918 108.853 73.189 108.657 73.2642 108.387L84.5082 72.9539C84.6587 72.4723 85.1102 72.1411 85.622 72.1411",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M103.338 92.8222L105.596 97.0519L109.675 92.8222L107.101 88.4722L103.338 92.8222Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M146.468 74.0578C147.296 68.5076 143.468 63.337 137.918 62.5087C132.368 61.6805 127.197 65.5084 126.369 71.0585C125.541 76.6086 129.368 81.7793 134.919 82.6075C140.469 83.4358 145.639 79.6079 146.468 74.0578Z",
    fill: "#FF5D0E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M136.408 66.8418V72.5616H143.844",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M128.582 18.1333H136.409V58.7589",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M136.408 60.5202C137.38 60.5202 138.169 59.7318 138.169 58.7591C138.169 57.7865 137.38 56.998 136.408 56.998C135.435 56.998 134.646 57.7865 134.646 58.7591C134.646 59.7318 135.435 60.5202 136.408 60.5202Z",
    fill: "#FF5D0E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M128.009 19.8947C128.982 19.8947 129.77 19.1063 129.77 18.1337C129.77 17.161 128.982 16.3726 128.009 16.3726C127.037 16.3726 126.248 17.161 126.248 18.1337C126.248 19.1063 127.037 19.8947 128.009 19.8947Z",
    fill: "#FF5D0E"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0.382812 110.839H148.616",
    stroke: "#0A0A0A",
    strokeWidth: 0.752604,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword);
export default __webpack_public_path__ + "static/media/resetPassword.eecb8c61acf7cdb8618c42ac1e34736b.svg";
export { ForwardRef as ReactComponent };